import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex items-center justify-center mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center shadow-professional">
            <Icon name="Calculator" size={28} color="white" />
          </div>
          <div className="text-left">
            <h1 className="text-2xl font-bold text-foreground">AccounTech AI</h1>
            <p className="text-sm text-muted-foreground">Intelligent Accounting Platform</p>
          </div>
        </div>
      </div>

      {/* Welcome Message */}
      <div className="mb-6">
        <h2 className="text-3xl font-bold text-foreground mb-2">
          Welcome Back
        </h2>
        <p className="text-muted-foreground text-lg">
          Sign in to access your comprehensive accounting dashboard
        </p>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-3 gap-4 mb-8">
        <div className="text-center p-3 bg-card border border-border rounded-lg">
          <div className="text-2xl font-bold text-primary mb-1">$2.5M+</div>
          <div className="text-xs text-muted-foreground">Transactions Processed</div>
        </div>
        <div className="text-center p-3 bg-card border border-border rounded-lg">
          <div className="text-2xl font-bold text-success mb-1">99.9%</div>
          <div className="text-xs text-muted-foreground">Accuracy Rate</div>
        </div>
        <div className="text-center p-3 bg-card border border-border rounded-lg">
          <div className="text-2xl font-bold text-accent mb-1">24/7</div>
          <div className="text-xs text-muted-foreground">AI Support</div>
        </div>
      </div>
    </div>
  );
};

export default LoginHeader;